module.exports = __webpack_public_path__ + "static/media/logo-new.7156ac82.svg";